import { useSelector } from "react-redux";

const BodyMapView = ({ bodyMaps }) => {
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);

  return (
    <div className="ph20">
      {(bodyMaps ?? reqDet?.bodymaps)?.map((frm, i) => (
        <div className="mt5 flex-row-ali-cen" key={frm?.mapId}>
          <a href={frm?.file} target="_blank" className="cursor">
            <img
              src={frm?.file?.replace(/^https:/, "http:")}
              className="imghw40 br5"
              alt=""
            />
          </a>
          {/* <div className="gray-dot" /> */}
          {/* <Typography className="fs12 blue-color font-medium ml5">
            {frm?.name}
          </Typography> */}
          {/* <a href={frm?.file} className="fs12 blue-color txt-regular ml5">
            {frm?.file}
          </a> */}
        </div>
      ))}
    </div>
  );
};

export default BodyMapView;
